import $ from 'jquery';


$(() => {
  const  productColumnCookieName = "prodColum";
  const columnViewContainer = $('.js-column-view');
  const columnButtons = columnViewContainer.find('.filter__view-input');

  const column = {
    3: {
      gridText: 'three',
      gridNumber: 3
    },
    4: {
      gridText: 'four',
      gridNumber: 4
    }
  }
  const initPLPJs = () => {
    columnButtons.on('click', ()=> {
      handleColumnClick(columnButtons)
    });
  }

  const triggerLayoutChangeEvent = () => {
      $(window).trigger('layout-change');
  }

  const handleColumnClick = () => {
    const selectedButton = columnButtons.filter(':checked');
    const columnNumber = selectedButton.data('columns');
    changeColumnView(columnNumber);
  }

  const changeColumnView = (numberColumns) => {
      const {gridNumber, gridText} = column[numberColumns];
      $(".products-grid").removeClass("n-block-grid--3 n-block-grid--4").addClass(`n-block-grid--${gridNumber}`);
      setCookie(productColumnCookieName, `${gridNumber}`, 30);
      triggerLayoutChangeEvent();
  };
  initPLPJs();
})



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/column-view.js